import { render, staticRenderFns } from "./A7PainelDesktop.vue?vue&type=template&id=80510f3c&scoped=true&lang=html&"
import script from "./A7PainelDesktop.vue?vue&type=script&lang=js&"
export * from "./A7PainelDesktop.vue?vue&type=script&lang=js&"
import style0 from "./A7PainelDesktop.vue?vue&type=style&index=0&id=80510f3c&lang=scss&scoped=true&"
import style1 from "./A7PainelDesktop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80510f3c",
  null
  
)

export default component.exports